import {Box, Typography} from '@mui/material';
import {PrivateRouteProps} from '../../config/routeType';

export default function ExerciseTitle({user}: PrivateRouteProps) {
  return (
    <Box sx={{mb: 4}} data-testid="welcome-message">
      <Typography variant="h4" sx={{fontWeight: 700, color: 'primary.main', mb: 1}}>
        Welcome back, {user.name || user.email?.split('@')[0] || 'Student'}!
      </Typography>
      <Typography variant="body1" sx={{color: 'text.secondary'}}>
        Ready to continue your GCSE revision journey?
      </Typography>
    </Box>
  );
}
